import { PurchaseInvoiceBaseModel, TableCells } from 'models';
import { formatNum } from 'utils';

import {
  PurchaseInvoiceText,
  PurchaseInvoiceTextGreen,
  PurchaseInvoiceTextOrange,
} from 'components';

function getStyledComponent(val: number | null | undefined | string) {
  switch (val) {
    case 100000003:
      return PurchaseInvoiceTextGreen;
    case 100000000:
    case 100000001:
    case 752560000:
      return PurchaseInvoiceTextOrange;
    default:
      return PurchaseInvoiceText;
  }
}

export const purchaseInvoicesTableCells: TableCells<PurchaseInvoiceBaseModel>[] =
  [
    {
      id: 'SellerInvoiceNumber',
      label: '#portal.purchaseinvoice.grid.sellerinvoicenumber',
      type: 'string',
    },
    {
      id: 'SellerOrganisationName',
      label: '#portal.purchaseinvoice.grid.sellerorganizationname',
      type: 'string',
      small: true,
      xs: true,
    },
    {
      id: 'AccountingDate',
      type: 'date',
      label: '#portal.purchaseinvoice.grid.accountingdate',
      style: { width: '12%' },
      small: true,
      xs: true,
    },
    {
      id: 'InvoiceDueDate',
      label: '#portal.purchaseinvoice.grid.invoiceduedate',
      type: 'date',
      style: { width: '12%' },
    },
    {
      id: 'TotalAmount.Value',
      label: '#portal.purchaseinvoice.grid.totalamount',
      type: 'number',
      small: true,
      xs: true,
      render: (purchaseInvoice) => {
        const Component = getStyledComponent(
          purchaseInvoice.PaymentStatus?.Value
        );
        return (
          <Component style={{ textAlign: 'right', fontWeight: 600 }}>
            {formatNum(purchaseInvoice.TotalAmount?.Value)}{' '}
            {purchaseInvoice.TotalAmount?.Symbol}
          </Component>
        );
      },
    },
    {
      id: 'PaymentStatus.Label',
      label: '#portal.purchaseinvoice.grid.paymentstatus',
      type: 'string',
      small: true,
      xs: false,
      render: (purchaseInvoice) => {
        const Component = getStyledComponent(
          purchaseInvoice.PaymentStatus?.Value
        );
        return <Component>{purchaseInvoice.PaymentStatus?.Label}</Component>;
      },
    },
    {
      id: 'BuyerAccountNumber.Name',
      label: '##attribute#invoice#uds_payerbankaccountid',
      type: 'string',
    },
  ];
